/**@jsx jsx */
import { Fragment, useEffect, useRef, useState } from 'react'
import { Flex, Button, jsx } from 'theme-ui'
import Text from '~/components/IntlComponents/Text'
import ArrowDown from '~/assets/images/arrow_down.svg'
import useMatchMedia from '~/hooks/utils/use-match-media'
const ArticleFilterDropdown = ({ filters, activeFilter, setFilter }) => {
  const [isOpen, setIsOpen] = useState(false)

  // Calculate height of opened and closed states so we can animate it
  const [closedHeight, setClosedHeight] = useState(49.5)
  const [openHeight, setOpenHeight] = useState(null)
  const dropdownBtn = useRef()
  const dropdownList = useRef()
  const isMobileViewport = useMatchMedia('(max-width: 1023px)')
  useEffect(() => {
    setClosedHeight(dropdownBtn.current?.clientHeight)
    setOpenHeight(
      dropdownList.current?.clientHeight + dropdownBtn.current?.clientHeight,
    )
    // Update heights if starting on desktop and shrinking screen to mobile
  }, [isMobileViewport])

  return (
    <Fragment>
      <Text
        as="div"
        sx={{
          color: 'brilliantRose',
          textAlign: 'center',
          fontSize: 0,
          fontWeight: 'extraBold',
          mb: '15px',
        }}
      >
        Categories
      </Text>
      <Flex
        sx={{
          position: 'relative',
          flexDirection: 'column',
          width: ['84%', '75%'],
          height: isOpen ? openHeight + 'px' : closedHeight + 'px',
          overflow: 'hidden',
          transition: 'height 0.2s cubic-bezier(.45,.97,.48,1.1)',
          m: '0 auto',
          mb: '15px',
          backgroundColor: 'brilliantRose',
          border: '2px solid',
          borderColor: 'brilliantRose',
          borderRadius: '8px',
          zIndex: 1,
          button: {
            textTransform: 'capitalize',
            textAlign: 'left',
            borderRadius: 0,
            height: 'auto',
            fontWeight: 'body',
            fontSize: 2,
          },
        }}
      >
        <Button
          ref={dropdownBtn}
          onClick={() => setIsOpen(!isOpen)}
          sx={{
            p: '15px 20px',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            color: 'brilliantRose',
            backgroundColor: 'white',
            fontWeight: '900 !important',
            width: '100%',
            ':hover': {
              backgroundColor: 'white',
            },
          }}
        >
          {activeFilter?.toLowerCase() || 'All'}{' '}
          <ArrowDown sx={{ transform: isOpen ? 'rotate(180deg)' : null }} />
        </Button>
        <Flex
          ref={dropdownList}
          sx={{
            flexDirection: 'column',
            button: {
              p: '10px 20px',
              backgroundColor: 'brilliantRose',
              color: 'white',
              ':active': {
                backgroundColor: 'rgba(247, 82, 173, 0.8)',
              },
            },
          }}
        >
          <Button
            sx={{
              ':hover': {
                backgroundColor: 'brilliantRose',
              },
            }}
            onClick={() => {
              setFilter(null)
              setIsOpen(false)
            }}
          >
            All
          </Button>
          {filters.map(filter => (
            <Button
              key={filter}
              sx={{
                ':hover': {
                  backgroundColor: 'brilliantRose',
                },
              }}
              onClick={() => {
                setFilter(filter)
                setIsOpen(false)
              }}
            >
              {filter.toLowerCase()}
            </Button>
          ))}
        </Flex>
      </Flex>
    </Fragment>
  )
}

export default ArticleFilterDropdown
